/**
 * HeatmapEditor
 *
 * Property editor for heatmap configuration
 */

import React from 'react';
import { ChartBaseEditor, type ChartBaseConfig } from './ChartBaseEditor';
import { TextPropertyEditor } from '../../BaseEditors/TextPropertyEditor';
import { SelectPropertyEditor } from '../../BaseEditors/SelectPropertyEditor';

export interface HeatmapEditorProps {
  config: Partial<ChartBaseConfig & {
    xKey?: string;
    yKey?: string;
    valueKey?: string;
    colorScale?: string;
  }>;
  onChange: (config: Partial<ChartBaseConfig>) => void;
}

export const HeatmapEditor: React.FC<HeatmapEditorProps> = ({ config, onChange }) => {
  return (
    <ChartBaseEditor config={config} onChange={onChange} chartType="Heatmap" showAxes={false}>
      <div className="chart-editor__section">
        <h3 className="chart-editor__section-title">Heatmap Options</h3>

        <TextPropertyEditor
          label="X Axis Key"
          value={(config.xKey as string) || 'x'}
          onChange={(xKey) => onChange({ ...config, xKey })}
          helpText="Property for column names"
          required
        />

        <TextPropertyEditor
          label="Y Axis Key"
          value={(config.yKey as string) || 'y'}
          onChange={(yKey) => onChange({ ...config, yKey })}
          helpText="Property for row names"
          required
        />

        <TextPropertyEditor
          label="Value Key"
          value={(config.valueKey as string) || 'value'}
          onChange={(valueKey) => onChange({ ...config, valueKey })}
          helpText="Property for cell values"
          required
        />

        <SelectPropertyEditor
          label="Color Scale"
          value={(config.colorScale as string) || 'viridis'}
          onChange={(colorScale) => onChange({ ...config, colorScale })}
          options={[
            { value: 'viridis', label: 'Viridis' },
            { value: 'heat', label: 'Heat (Blue to Red)' },
            { value: 'cool', label: 'Cool (Blue to Green)' },
            { value: 'greyscale', label: 'Greyscale' },
          ]}
        />
      </div>
    </ChartBaseEditor>
  );
};

HeatmapEditor.displayName = 'HeatmapEditor';
